import { render } from "./CardStats.vue?vue&type=template&id=296f8d55"
import script from "./CardStats.vue?vue&type=script&lang=js"
export * from "./CardStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__